<template>
  <div class="register customer-common">
    <div class="greeting">
      <div></div>
      <p>终于等到你</p>
    </div>
    <div class="register-handle cus-style">
      <div class="input">
        <van-field
          class="inputPhone"
          v-model="phone"
          center
          maxlength="11"
          placeholder="请输入手机号"
          :error="validate.reg_verify_err.phone"
          @change="gettel('phone')"
        >
          <template #button>
            <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
              <template #reference>
                <div class="overallbaseline arrowBox">
                  <div>{{actionsValue}}</div>
                  <img class="arrow" :style="showPopover?'':'transform:rotate(-90deg)'" :src="require('../../assets/images/arrow.png')" alt="">
                </div>
              </template>
            </van-popover>
          </template>
        </van-field>
        <van-field
          v-model="code"
          center
          clearable
          placeholder="请输入验证码"
          type="digit"
          max-length="6"
          :error="validate.reg_verify_err.code"
          @change="validate.code('code')"
        >
          <template #button>
            <span size="small" round @click="sendCode" style="color: #6cdd8f">{{
              sendClip ? "发送验证码" : `${second}s`
            }}</span>
          </template>
        </van-field>
        <van-field
          v-model="pwd"
          center
          type="password"
          clearable
          placeholder="请设置6-16位登录密码"
          :error="validate.reg_verify_err.pwd"
          @change="validate.pwd('pwd')"
        >
        </van-field>
        <van-field
          v-model="rpwd"
          type="password"
          center
          clearable
          placeholder="再次输入密码"
          :error="validate.reg_verify_err.rpwd"
          @change="validate.rpwd('pwd', 'rpwd')"
        >
        </van-field>
      </div>
      <div class="agreement">
        <van-checkbox v-model="agree">
          <template #icon="props">
            <img
              class="img-icon"
              :src="
                props.checked
                  ? require('../../assets/images/login/checked-ico.png')
                  : require('../../assets/images/login/unchecked-ico.png')
              "
            />
          </template>
        </van-checkbox>
        注册即代表您同意<span @click="$router.push('/useragreement')">
          《用户服务协议》</span>
      </div>
      <div class="register-btn">
        <van-button
          size="large"
          color="linear-gradient(to right, #5DD682, #5AFF8E)"
          @click="fnRegister"
          >注册</van-button>
      </div>
      <div class="to-login" @click="$router.push('/login')">
        已有账户，立即登录
      </div>
    </div>
  </div>
</template>

<script>
import { registerPlayer, getRegiserTelCode } from "../../utils/api/user";
import { validate } from "@/utils/mixin/validate";
export default {
  mixins: [validate],
  data() {
    return {
      // 手机号
      phone: "",
      // 短信验证码
      code: "",
      // 密码
      pwd: "",
      // 二次密码
      rpwd: "",
      // 是否同意
      agree: false,
      // 是否能发送短信
      sendClip: true,
      // 定时器
      itv: null,
      // 定时器秒
      second: 60,
      showPopover:false,
      actions: [
        { text: '中国大陆+86',value:86 }, 
        { text: '中国香港+852',value:852 }, 
        { text: '中国澳门+853',value:852}
      ],
      actionsValue:'中国大陆+86'
    };
  },
  methods: {
    onSelect(action) {
      this.actionsValue = action.text;
      this.phone = '';
    },
    gettel(key){
      let val = this[key];
      if (this.validate.formDataKey) {
        val = this[this.validate.formDataKey][key];
      }
      let res = '';
      if(this.actionsValue == '中国香港+852' || this.actionsValue == '中国澳门+853'){
        res = val.length == 8;
      }else{
        res = val.length == 11;
      }
      if (!res) {
        this.validate.reg_verify_err_msg[key] = `请输入正确的手机号`;
        this.$toast.fail("请输入正确的手机号");
      } else {
        this.validate.reg_verify_err_msg[key] = "";
      }
      this.validate.reg_verify_err[key] = !res;
      this.$forceUpdate();
      return res
    },
    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      const res = this.gettel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      let phone = this.phone;
      if( this.actionsValue == '中国香港+852'){
        phone = '852' + this.phone;
      }
      if( this.actionsValue == '中国澳门+853'){
        phone = '853' + this.phone;
      }
      getRegiserTelCode(phone).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },
    // 注册
    fnRegister() {
      this.$toast.loading({
        message: '注册中...',
        forbidClick: true,
        duration: 0,
      });
      const res = this.gettel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      if (!this.agree) {
        this.$root.$toast.fail("请查看并同意用户协议");
        return;
      }
      if (this.pwd !== this.rpwd) {
        this.$root.$toast.fail("两次输入的密码不一致");
        return;
      }
      const params = {
        code: this.phone,
        password: this.pwd,
        telCode: this.code
      };
      if( this.actionsValue == '中国香港+852'){
        params.code = '852' + this.phone;
      }
      if( this.actionsValue =='中国澳门+853'){
        params.code = '853' + this.phone;
      }
      registerPlayer(params).then((res) => {
        if (res.success) {
          this.$root.$toast.success({
            duration: 2000,
            message: "注册成功，即将跳转登录页面",
            onClose: () => {
              this.$router.push("/login");
            }
          });
        }
      });
    }
  },
  mounted() {
    // eslint-disable-next-line
    this.verification = new Verification.Init();
  }
};
</script>

<style lang="scss" scoped>
.register {
  .greeting {
    width: 100%;
    color: #666;
    overflow: hidden;
    min-height: 120px;
    & > div {
      margin-top: 16px;
      height: 67px;
      background-image: url("../../assets/images/login/welcome-ico.png");
      background-repeat: no-repeat;
      background-size: 167px 67px;
      background-position: center center;
    }
    & > p {
      font-size: 20px;
      margin-top: 10px;
      color: #333;
      font-weight: 700;
    }
  }
  .register-handle {
    margin-top: 14px;
    .input {
      width: 335px;
      overflow: hidden;
      margin: 0 auto;
      margin-bottom: 20px;
      min-height: 192px;
      .pwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .rpwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .phone-ico {
        background: url("../../assets/images/login/phone.png") no-repeat;
      }
      .mail-ico {
        background: url("../../assets/images/login/mail.png") no-repeat;
      }
      .inp-ico {
        width: 55px;
        height: 55px;
        background-size: 20px 20px;
        background-position: center center;
      }
    }
    .agreement {
      width: 335px;
      margin: 0 auto;
      margin-top: 24px;
      height: 20px;
      align-items: center;
      display: flex;
      font-size: 12px;
      color: #333333;
      display: flex;
      justify-content: center;
      span {
        margin-left: 5px;
      }
    }
    .register-btn {
      width: 335px;
      margin: 0 auto;
      margin-top: 85px;
    }
    .to-login {
      font-size: 14px;
      margin-top: 16px;
      color: #666;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.inputPhone{
  .van-field__body{
    display: flex;
    flex-direction: row-reverse;
  }
  .van-field__button{
    padding-left:0px !important;
    padding-right:5px !important;
  }
  .arrowBox{
    width: 96px;
    min-width: 100PX;
  }
  .arrow{
    width: 8px !important;
    height: 8px !important;
    margin-left: 4px;
  }
}
</style>
